export enum ClinicLaboratoryModel {
    All = "all",
    Public = "public",
    Private = "private",
}

export default interface Clinic {
    street: string;
    suite?: string;
    city: string;
    province: string;
    postalCode: string;
    code?: string | number | null;
    distanceInMeters?: number;
    googleLocationId?: string | null;
    id: number;
    laboratoryModel: ClinicLaboratoryModel;
    name: string;
    nextAvailableTime: string | null;
    timezone: string;
    directionsDetailsEn?: string | null;
    directionsDetailsFr?: string | null;
    clinicImage?: string | null;
    googleMapsLink?: string | null;
}
